module.exports = __webpack_public_path__ + "static/img/zt1-pic2.e005f6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt1-pic2.jpg
// module id = Bc9Y
// module chunks = 171